// src/types/categories.ts

import { 
  faCar, 
  faHome, 
  faMobileAlt, 
  faLaptop, 
  faCouch, 
  faBrush, 
  faTshirt, 
  faBriefcase, 
  faHospital, 
  faUtensils, 
  faStore, 
  faBuilding, 
  faHardHat, 
  faSeedling, 
  faPlane,
  faGlobe
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Stall Categories - Remove "as const" to make them mutable arrays
export const stallCategories = [
  
  'Boutique Businesses',
  'Electronic Shops/Stores',
  'Supermarkets', 
  'Hardware stores/shops',
  'Food manufacturers & distributors',
  'Health & Wellness products distributors',
  'Hotels, Lodges and Guest House Businesses',
  'Airbnb',
  'Construction Companies',
  'Interior Designers',
  'Tailors & fashion Designers',
  'Clothes, Text tile, Shoes and Beddings Businesses',
  'Restaurants & Cafes',
  'Catering Service Providers',
  'Travel & Tour Companies',
  'Energy Suppliers (Including solar)',
  'Consultancy Firms',
  'Insurance Companies',
  'Tax Consultants',
  'Law Firms',
  'Car Hire & Transport Service Providers',
  'Retail Shops',
  'Grocery Businesses',
  'Drinks manufacturers and distributors (water, soft drinks, beer, wines, spirits and other beverages)', 
  'Hung out places, Bars and Leisure Gardens',
  'Event Venues (wedding halls, Gardens & Concert venues)',
  'Recreation Centres (Sand Beaches, Leisure Parks, resorts, etc)',
  'Sports betting & gambling Companies',
  'Cinema Halls',
  'Hospitals, Clinics, Drug shops & Pharmacies',
  'Health Clubs (Fitness & Gyms, Sauna, Steam, Spa and Massage)',
  'Wholesale shops',
  'Auto Services Shops (Parts, Accessories & Repairs)',
  'Oil and Gas Companies (Including fuel stations)',
  'Movers/Removalists', 
  'Recruitment Firms/Agencies (Jobs & Career Opportunities)',
  'Furniture and Metal works Businesses',
  'Home Appliance Businesses', 
  'Decorations (Decor) Service Providers',
  'Gardens & Compound Designers',
  'Cleaning and Fumigation Businesses',
  'Laundry & Dry Cleaners',
  'Beauty Shops (Cosmetics, Fragrances and perfumes, Skincare & skincare products, Hair Salon & Hair-care products, Nails care and Nails care products, Makeup services)',
  'Jewellery & Gift Shops',
  'Logistics, Clearing & Forwarding Companies',
  'Telecom & Network Companies',
  'Schools, Institutes, Colleges & Universities',
  'Land and Buildings',
  'Car Dealers',
  'Importers and Exporters',
  'Audit & Accounting Firms',
  'IT Service Providers',
  'Electrical Engineering Companies',
  'Plumbing Companies',
  'Mechanical Engineering Companies',
  'Factories & Processing Companies',
  'Photocopying, Printing & Branding Companies',
  'Event Planners',
  'Sound & Production Service Providers',
  'Photography & Videography Service Providers',
  'Artists, Performers & Cultural Dancers',
  'Fishing Companies',
  'Farm Produce Suppliers',
  'Livestock & Livestock Products Suppliers',
  'General Equipment Suppliers',
  'Agro Suppliers (Seeds, Fertilizers & other Agricultural products)',
  'Poultry & Poultry Products Suppliers (Chicken, Eggs)',
  'Airline Booking and Visa Companies',
  'Other Businesses / Companies / Organisations'
];

// Real Estate Categories - Remove "as const" to make them mutable arrays
export const realEstateCategories = [  
  'Equipment',
  'Land',
  'Residential Houses', 
  'Buildings (Shopping Malls , Arcades, Apartment , Hotels , Restaurants , Schools , Hospitals , Rentals &Leasing)',
  'Cars', 
  'General Property Sales',
  'Property Management',
  'Job Opportunities'
];

// Category Icons Mapping
export const categoryIcons: Record<string, IconDefinition> = {
  'All Categories': faGlobe,
  'Cars': faCar,
  'Property': faHome,
  'Mobile Phones & Tablets': faMobileAlt,
  'Electronics': faLaptop,
  'Home, Furniture & Appliances': faCouch,
  'Beauty & Personal Care': faBrush,
  'Fashion': faTshirt,
  'Jobs': faBriefcase,
  'Hospitals, Pharmacies & Clinics': faHospital,
  'Restaurants & Cafes': faUtensils,
  'Supermarkets': faStore,
  'Land': faBuilding,
  'Residential Houses': faHome,
  'Apartments': faBuilding,
  'Farm Produce': faSeedling,
  'Tour & travel': faPlane,
  'Buildings (Shopping Malls , Arcades, Apartment , Hotels , Restaurants , Schools , Hospitals , Rentals &Leasing)': faBuilding,
  'Equipment': faHardHat,
  'General Property Sales': faBuilding,
  'Property Management': faBuilding,
  'Job Opportunities': faBriefcase,
};

// Type exports for TypeScript (optional - if you want strict typing)
export type StallCategory = string; // More flexible approach
export type RealEstateCategory = string; // More flexible approach
export type AllCategories = string; // More flexible approach